export default function SeoContent() {
  return (
    <section className="text-grayD1 space-y-4">
      <h1 className="text-[1.25rem] lg:text-[1.5rem] font-bold leading-[190%]">
        Best Pet Shop in Bangladesh – Buy Premium Pet Food & Accessories with
        Fast Delivery!
      </h1>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem]">
        <span className="font-bold">Amarpet</span> is your trusted pet shop in
        Bangladesh, offering everything your pets need. Our selection includes
        high-quality cat food, dog food, rabbit food, bird food, and essential
        pet accessories. Whether you need nutritious meals for your cats and
        dogs or supplies for rabbits and birds,&nbsp;
        <span className="font-bold">Amarpet</span> has it all. Experience
        exceptional service and competitive prices at your reliable pet shop!
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Best Cat Food in Bangladesh for All Breeds & Ages
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Discover our range of premium cat products for health and happiness. We
        provide nutritious cat food from trusted brands like&nbsp;
        <a
          href="https://amarpet.com/brands/reflex-plus"
          target="_blank"
          className="underline text-blue"
        >
          Reflex Plus
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/kitchen-flavour"
          target="_blank"
          className="underline text-blue"
        >
          Kitchen Flavour
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/nature-bridge"
          target="_blank"
          className="underline text-blue"
        >
          Nature Bridge
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/smartheart"
          target="_blank"
          className="underline text-blue"
        >
          SmartHeart
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/whiskas"
          target="_blank"
          className="underline text-blue"
        >
          Whiskas
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/lara"
          target="_blank"
          className="underline text-blue"
        >
          Lara
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/bonacibo"
          target="_blank"
          className="underline text-blue"
        >
          Bonacibo
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/kaniva"
          target="_blank"
          className="underline text-blue"
        >
          Kaniva
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/truly"
          target="_blank"
          className="underline text-blue"
        >
          Truly
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/wanpy"
          target="_blank"
          className="underline text-blue"
        >
          Wanpy
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/drools"
          target="_blank"
          className="underline text-blue"
        >
          Drools
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/faenbei"
          target="_blank"
          className="underline text-blue"
        >
          Faenbei
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/bellotta"
          target="_blank"
          className="underline text-blue"
        >
          Bellotta
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/lola-and-co"
          target="_blank"
          className="underline text-blue"
        >
          Lola & Co
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/jungle"
          target="_blank"
          className="underline text-blue"
        >
          Jungle
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/haisenpet"
          target="_blank"
          className="underline text-blue"
        >
          Haisenpet
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/product/felicia-low-grain-starter-care-kitten-chicken-2kg"
          target="_blank"
          className="underline text-blue"
        >
          Felicia
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/billi"
          target="_blank"
          className="underline text-blue"
        >
          Billi
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/paw-paw"
          target="_blank"
          className="underline text-blue"
        >
          Paw Paw
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/trendline"
          target="_blank"
          className="underline text-blue"
        >
          Trendline
        </a>
        , and more. <br />
        <br /> We also offer essential&nbsp;
        <a
          href="https://amarpet.com/category/cat-litter"
          target="_blank"
          className="underline text-blue"
        >
          cat litter
        </a>
        , including clumping, non-clumping, and biodegradable options. Our
        litter boxes come in various sizes and styles to suit your cat&apos;s
        needs, from covered boxes for privacy to open designs for easy access.
        <br />
        <br />
        Additionally, explore our selection of&nbsp;
        <a
          href="https://amarpet.com/category/cat-accessories"
          target="_blank"
          className="underline text-blue"
        >
          toys
        </a>
        , scratching posts,&nbsp;
        <a
          href="https://amarpet.com/category/clothing-beds-carrier"
          target="_blank"
          className="underline text-blue"
        >
          cat clothing, beds, carriers
        </a>
        , and grooming tools to keep your cat entertained and well-groomed.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Premium Dog Food in Bangladesh – Healthy & Affordable
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Show your dog&apos;s love with our premium dog food and care products.
        Our selection features top brands like&nbsp;
        <a
          href="https://amarpet.com/brands/smartheart"
          target="_blank"
          className="underline text-blue"
        >
          SmartHeart
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/internutri"
          target="_blank"
          className="underline text-blue"
        >
          InterNutri
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/drools"
          target="_blank"
          className="underline text-blue"
        >
          Drools
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/truly"
          target="_blank"
          className="underline text-blue"
        >
          Truly
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/wanpy"
          target="_blank"
          className="underline text-blue"
        >
          Wanpy
        </a>
        &nbsp;and more for balanced nutrition. <br />
        <br /> We offer dog care products, including grooming supplies and
        health supplements. Our stylish accessories, such as collars, leashes,
        and toys, help keep your dog active and engaged.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Buy Rabbit Food Online in Bangladesh with Fast Delivery
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Keep your rabbits nourished with our premium rabbit food. We provide
        healthy pellets and mixes tailored to their dietary needs. Brands
        like&nbsp;
        <a
          href="https://amarpet.com/brands/smartheart"
          target="_blank"
          className="underline text-blue"
        >
          SmartHeart
        </a>
        ,&nbsp;
        <a
          href="https://amarpet.com/brands/jungle"
          target="_blank"
          className="underline text-blue"
        >
          Jungle
        </a>
        &nbsp;and&nbsp;
        <a
          href="https://amarpet.com/brands/quik"
          target="_blank"
          className="underline text-blue"
        >
          Quik
        </a>
        &nbsp;ensure quality ingredients for your rabbits. <br />
        <br />
        Our rabbit food supports digestive health. We also offer bedding and
        accessories to create a comfortable living environment.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Best Quality Bird Food in Bangladesh
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Feed your birds with our nutritious food, providing essential vitamins
        and minerals. We offer seeds, pellets, and mixes for various bird
        species, featuring brands like&nbsp;
        <a
          href="https://amarpet.com/brands/petslife"
          target="_blank"
          className="underline text-blue"
        >
          petslife
        </a>
        , Goldwings, and more. <br />
        <br />
        In addition, we provide bird accessories, including feeders, waterers,
        and toys for mental stimulation and activity.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Special Offers
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        <span className="font-semibold">
          5% Off on Your 1st Order via Our App
        </span>
        <br />
        <a
          href="https://onelink.to/2mpyxc"
          target="_blank"
          className="underline text-blue"
        >
          Download our app
        </a>
        &nbsp;for exclusive discounts on your first order. <br />
        <br />
        <span className="font-semibold">
          Up to 32% Off on Selected Cat & Dog Food!
        </span>
        <br />
        <a
          href="https://amarpet.com/offers"
          target="_blank"
          className="underline text-blue"
        >
          Save on premium pet food & accessories
        </a>
        &nbsp;with our limited-time discounts.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Pet Food in Bangladesh – One Stop Solution for All Pet Needs
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Looking for the best pet food in Bangladesh?{" "}
        <span className="font-bold">AmarPet</span> brings you a complete and
        reliable solution for all your pet&apos;s nutritional needs. As one of
        the largest online pet food stores in Bangladesh, AmarPet offers a wide
        range of high-quality food for cats and dogs—carefully selected to
        ensure health, taste, and balanced nutrition.
        <br />
        <br />
        At AmarPet, you&apos;ll find everything from dry food, wet food, and
        treats to specialized diets for puppies, kittens, adults, and senior
        pets. We feature trusted international and local brands known for their
        quality ingredients and safety standards, helping your pets stay
        active, healthy, and happy.
        <br />
        <br />
        Whether your pet needs grain-free formulas, high-protein meals, or
        sensitive digestion support, AmarPet makes it easy to choose the right
        food with detailed product information and expert-backed selections.
        <br />
        <br />
        Enjoy convenient online shopping, competitive pricing, and fast
        delivery across Bangladesh. With AmarPet, you&apos;re not just buying
        pet food—you&apos;re ensuring better care and a healthier life for
        your beloved companion.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Why Choose AmarPet?
      </h2>
      <ul className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] list-disc pl-6 space-y-1">
        <li>Wide collection of premium pet food brands</li>
        <li>All life stage cat food (Kitten, Puppy, Adult, Senior)</li>
        <li>100% authentic and high quality imported products</li>
        <li>Affordable pricing with regular offers</li>
        <li>Fast & reliable delivery nationwide</li>
      </ul>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Shop now at <span className="font-bold">AmarPet</span> and give your
        pet the nutrition they deserve. 🐾
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Online Pet Food Delivery in Bangladesh – Fast, Reliable & Hassle-Free
        with AmarPet
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Searching for convenient online pet food delivery in Bangladesh?{" "}
        <span className="font-bold">AmarPet</span> makes caring for your pets
        easier than ever with a wide selection of quality food delivered right
        to your doorstep.
        <br />
        <br />
        As a trusted online pet store, AmarPet offers premium dry food, wet
        food, treats, and specialized diets for cats and dogs of all ages.
        Whether you have a playful kitten, an active puppy, or a senior pet,
        you&apos;ll find the perfect nutrition from top-quality brands—all in
        one place.
        <br />
        <br />
        Skip the hassle of wandering around the store and enjoy a smooth
        online shopping experience with easy ordering, competitive prices, and
        regular deals. Every product is carefully sourced to ensure
        authenticity and safety, so you can feed your pet with confidence.
        <br />
        <br />
        With fast and reliable delivery across Bangladesh, AmarPet ensures
        your pet never runs out of their favorite food.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Buy Pet Accessories Online in Bangladesh – Cat Carrier, Toys, Grooming
        & More
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Upgrade your pet&apos;s lifestyle with the best{" "}
        <a
          href="https://amarpet.com/category/cat-accessories"
          target="_blank"
          className="underline text-blue"
        >
          pet accessories
        </a>{" "}
        in Bangladesh, all in one place at{" "}
        <span className="font-bold">AmarPet</span>. From comfortable cat
        carriers to fun toys and essential grooming products, AmarPet offers
        everything you need to keep your pets happy, healthy, and well cared
        for.
        <br />
        <br />
        Explore a wide range of accessories designed for both cats and
        dogs—whether it&apos;s a durable carrier for safe travel, interactive
        toys to keep them active, or grooming tools to maintain hygiene and
        coat health. Every product is carefully selected to ensure quality,
        comfort, and safety for your beloved pets.
        <br />
        <br />
        Shopping at AmarPet is simple and convenient. Browse, choose, and
        order online in just a few clicks—then enjoy fast delivery anywhere in
        Bangladesh.
      </p>

      <h2 className="text-[1.125rem] lg:text-[1.25rem] font-semibold leading-[190%]">
        Buy Cat Litter Online in Bangladesh – Fast Delivery & Best Quality at
        AmarPet
      </h2>
      <p className="text-grayD2 leading-[162.5%] text-[0.938rem] lg:text-[1rem] break-words">
        Looking to buy{" "}
        <a
          href="https://amarpet.com/category/cat-litter"
          target="_blank"
          className="underline text-blue"
        >
          cat litter
        </a>{" "}
        online in Bangladesh? <span className="font-bold">AmarPet</span>{" "}
        offers a complete range of premium cat litter designed for maximum
        hygiene, odor control, and convenience—delivered fast to your
        doorstep.
        <br />
        <br />
        Choose from high-quality options like bentonite, tofu, and eco-friendly
        cat litter that provide strong clumping, high absorption, and low
        dust—keeping your home clean and fresh. Popular choices such as
        Haisenpet, Paws, Bioline, Coziecat, Tidycats, Snowycat, Shifaa, and DL
        are known for their superior odor control and long-lasting
        performance, making daily cleaning easier and more efficient.
        <br />
        <br />
        Whether you prefer scented (lavender, lemon, coffee, apple, rose) or
        unscented litter, AmarPet has options to match your cat&apos;s comfort
        and your lifestyle.
      </p>
    </section>
  );
}